import { render, staticRenderFns } from "./FaqsList.vue?vue&type=template&id=403f5d42&scoped=true&"
import script from "./FaqsList.vue?vue&type=script&lang=js&"
export * from "./FaqsList.vue?vue&type=script&lang=js&"
import style0 from "./FaqsList.vue?vue&type=style&index=0&id=403f5d42&prod&lang=scss&scoped=true&"
import style1 from "./FaqsList.vue?vue&type=style&index=1&id=403f5d42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403f5d42",
  null
  
)

export default component.exports